import React from 'react'

function Skeleton() {
  return (
    <div className="h-full w-full rounded bg-zinc-300">
      <div className="skeleton !h-full !w-full !rounded"></div>
    </div>
  )
}

export default Skeleton
